import styled from '@emotion/styled'

import { Row as DefaultRow, Col as DefaultCol } from '../../UI/Grid'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.l}) {
    transform: translateY(200px);
    margin-bottom: 200px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.m}) {
    transform: translateY(110px);
    margin-bottom: 110px;
  }
`

export const InnerWrapper = styled.div`
  width: 100%;
  max-width: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.black};
`

export const Text = styled.p`
  padding: 16px 0;
  color: ${({ theme }) => theme.colors.black};
`

export const Row = styled(DefaultRow)`
  justify-content: space-between;
`

export const Col = styled(DefaultCol)`
  padding-top: 16px;
  max-width: 50%;
`

export const StepTitle = styled.h4`
  font-size: 1rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
`
